<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <b>Interncon 2020</b>: The most epic conference organized by interns for interns. <a href="https://internconference.com/" target="_blank">Learn more and register.</a>
      </div>
    </div>
    <div class="fullcard yellow-1st padding-1st">
      <div class="center800">
        <div class="internclub-brand">
          intern.club
        </div>
        <div class="headlines">
          <div class="text-head">
            The place to meet other interns, build your network, and make friends.
          </div>
          <div class="text-subhead">
            Made by interns and new grads (not recruiters).
          </div>
        </div>
        <InternRegistration key="top-reg" />
        <div class="socialproof">
          <div class="text-marketing">
            <p><a href="https://internclub.substack.com" target="_blank">Or check out our newsletter to see what we are like</a></p>
          </div>
          <div class="text-subhead">
            Join <b>5,000+</b> other interns who have brought their summers
            online .
          </div>
          <div class="schools">
            <img src="/phil/image 1.png" class="school-logo" />
            <img src="/phil/image 2.png" class="school-logo" />
            <img src="/phil/image 3.png" class="school-logo" />
            <img src="/phil/image 4.png" class="school-logo" />
            <img src="/phil/image 5.png" class="school-logo" />
            <img src="/phil/image 6.png" class="school-logo" />
            <img src="/phil/image7.png" class="school-logo" />
            <img src="/phil/image 8.png" class="school-logo" />
            <img src="/phil/image 9.png" class="school-logo" />
            <img src="/phil/image 10.png" class="school-logo" />
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; align-items: center; justify-content: center;">
      <Flipper :photos="photos" />
    </div>
    <div class="fullcard dark-1st padding-1st">
      <div class="text-large-body center800" style="color: white;">
        One of the greatest things about interning is the ability to meet people
        from all over the world -- to learn from others, build cool things, and
        create lifelong memories.
        <b style="color: #EC6569;"
          >Without a doubt, that’s a little harder this year.</b
        >
        <br /><br />But it’s not impossible.
        <b style="color:#59A5F8;">We’ve just got to stick together.</b>
      </div>
    </div>
    <div class="fullcard blue-1st padding-2nd">
      <div class="text-large-body center1200" style="color: white;">
        Join our Slack group to <b>get connected with your peers</b>, move
        forward in your career by
        <b>networking and attending virtual events</b>, and
        <b>meet people in industry</b> who can help you find your path.
      </div>
    </div>
    <div class="fullcard white-1st padding-2nd">
      <div class="testimonial center800">
        <div class="tm-text">
          Through intern.club. I met friends who I will likely have for the rest
          of my life, received and shared career advice and was inspired to
          create a community of my own back at Williams College. intern.club
          reinforced the fact that life is a team sport so we should help each
          other be the best that we can be.
        </div>
        <div class="tm-source">
          <img src="/phil/kai.png" class="profile-img" />
          <div><b>Kai Cash</b><br />Williams College</div>
        </div>
      </div>
    </div>
    <div class="fullcard padding-2nd footer">
      <div class="center800">
        <div class="text-subhead">
          Join <b>5,000+</b> other interns who have brought their summer online.
        </div>
        <InternRegistration key="bot-reg" />
        <div class="text-subhead" style="margin-top: 80px;">
          <p>
            From the folks who brought you intern.community
          </p>
          <p>
            Contact us at
            <a
              href="mailto:aanant@umich.edu"
              style="text-decoration: none;color:#59A5F8"
              >aanant@umich.edu</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InternRegistration from './InternRegistration.vue';
import Flipper from './Flipper.vue';

export default {
  name: 'PhilHome',
  components: { InternRegistration, Flipper },
  data() {
    return {
      photos: [
        {
          imageUrl: 'intern-photos/bonfire.png',
          alt: 'Five interns posing next to each other at a bonfire event.',
          caption: 'Real interns. Real connections.',
        },
        {
          imageUrl: 'intern-photos/bonfire-2.png',
          alt: 'Interns on the beach shaking hands.',
          caption: 'Real interns. Not stock photos.',
        },
        {
          imageUrl: 'intern-photos/pool.png',
          alt: 'Lots of people around a pool at a pool party.',
          caption: 'Real interns. Real connections.',
        },
        {
          imageUrl: 'intern-photos/hanging-out.png',
          alt:
            'Interns chatting in front of a grafitti wall, with one man pointing at the camera.',
          caption: 'Real interns. Not stock photos.',
        },
        {
          imageUrl: 'intern-photos/andyblueyo.png',
          alt: 'A woman with an intern community sticker on her forehead.',
          caption: 'Join our intern community!',
        },
        {
          imageUrl: 'intern-photos/some-pals.png',
          alt: 'Seven interns posing next to each other.',
          caption: 'Interns from Howard University.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
/* CSS files add styling rules to your content */

.banner {
  margin: 12px;
  font-family: 'Cabin', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: var(--small-text);
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}

.fullcard {
  margin: 12px;
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 0px;
  display: flex;
  flex-grow: 1;
  border-radius: 12px;
}

.padding-1st {
  padding: 100px;
  padding-left: 40px;
  padding-right: 40px;
}

.padding-2nd {
  padding: 80px;
  padding-left: 40px;
  padding-right: 40px;
}

.yellow-1st {
  background-color: #fbe869;
}

.dark-1st {
  background-color: #232323;
}

.white-1st {
  background-color: #ffffff;
  border: 8px solid #f1f1f1;
}

.blue-1st {
  background-color: #59a5f8;
}

.center800 {
  max-width: 800px;
  margin: auto;
}

.center1200 {
  max-width: 1200px;
  margin: auto;
}

.socialproof {
  margin-top: 3em;
}

.internclub-brand {
  font-family: 'Avenir', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 48px;
  text-align: center;
  color: #000000;
}

.text-head {
  font-family: 'Cabin', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: var(--xl-text);
  text-align: center;
  color: #000000;
}

.text-subhead {
  font-family: 'Cabin', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: var(--med-text);
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}

.text-marketing {
  font-family: 'Cabin', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: var(--small-text);
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}

.headlines {
  display: flex;
  flex-direction: column;
}

.headlines > div {
  margin-bottom: 20px;
  margin-top: 20px;
}

.email-form {
  margin: auto;
  margin-top: 20px;
  margin-bottom: 40px;
  max-width: max-content;
}

.email-input {
  background: #fef9d9;
  border-radius: 9999px;
  box-shadow: 0px 4px 60px rgba(70, 70, 70, 0.2);
  min-width: var(--email-width);
  height: 53px;
  border: none;
  font-size: var(--med-text);
  font-weight: 600;
  padding-left: 20px;
  font-family: 'Avenir', sans-serif;
}

.email-submit {
  background: #ec6569;
  border-radius: 9999px;
  height: 53px;
  border: none;
  font-size: var(--med-text);
  margin: 12px;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: 600;
  font-family: 'Avenir', sans-serif;
  color: white;
}

.schools {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-content: space-around;
  margin-top: 40px;
}

img.school-logo {
  max-height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  opacity: 0.5;
}

img.school-logo:hover {
  opacity: 0.75;
  transition: all 0.1s ease-in-out;
}

.text-large-body {
  font-size: var(--big-text);
  font-family: 'Avenir', sans-serif;
  display: inline;
}

.tm-text {
  font-size: var(--big-text);
  color: #59a5f8;
  font-family: 'Avenir', sans-serif;
  font-weight: 600;
}

.profile-img {
  border-radius: 9999px;
  height: 100px;
  float: left;
  margin-right: 40px;
}

.tm-source {
  font-family: 'Cabin', sans-serif;
  color: #232323;
  font-size: var(--med-text);
  display: flex;
  margin-top: 40px;
  align-items: center;
}
</style>
